import { cn } from "@/utils";
import React, { useState } from "react";

type Props = {
  images: string[];
};

// const usePreloadImages = (images: string[]) => {
//   useEffect(() => {
//     images.forEach((src) => {
//       const img = new Image();
//       img.src = src;
//     });
//   }, [images]);
// };

interface FadeImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {}

const FadeImage = ({ src, className, ...rest }: FadeImageProps) => {
  const defaultImageClassName = "object-cover size-full";

  return (
    <img
      src={src}
      alt="Faded"
      className={`${className} ${defaultImageClassName}`}
      {...rest}
    />
  );
};

const ImageGallery: React.FC<Props> = ({ images }) => {
  // usePreloadImages(images);
  const [isShowAll, setShowAll] = useState(false);

  const showAll = () => {
    setShowAll(true);
  };

  const length = images.length;

  return (
    <div>
      {isShowAll && (
        <div className="grid grid-cols-1 lg:grid-cols-2">
          {images.map((image, index) => (
            <FadeImage key={index} src={image} />
          ))}
        </div>
      )}

      {!isShowAll && (
        <div
          className={cn(
            "grid grid-cols-1 lg:grid-cols-2",
            length < 2 && "lg:grid-cols-1" // 1 image thì 1 cột
          )}
        >
          {length <= 4 &&
            images.map((image, index) => <FadeImage key={index} src={image} />)}

          {length > 4 && (
            <>
              {images.slice(0, 3).map((image, index) => (
                <FadeImage key={index} src={image} />
              ))}

              <div className="relative">
                <FadeImage key={4} src={images[3]} />
                <div
                  className="absolute inset-0 flex items-center justify-center bg-light_primary/70 cursor-pointer"
                  onClick={showAll}
                >
                  <span className="text-dark_primary text-lg font-bold leading-7 ">
                    +{length - 4}
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export { ImageGallery };
